var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tooltip)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipConf),expression:"tooltipConf"}],class:'cly-vue-tooltip-icon' + _vm.icon}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }